import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-salesofficetype-dropdown',
  templateUrl: './SalesOfficeTypeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => SalesOfficeTypeDropdownComponent)}]
})
export class SalesOfficeTypeDropdownComponent extends BaseDropdownComponent {

    
    
    
    public salesOfficesTypes: ent.SalesOfficeType[] = [];

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getSalesOfficeTypes().subscribe(x=>
            {
                this.selectItems.push({label:"", value:Constants._NONE});
                x.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
                x.forEach(y=> this.salesOfficesTypes.push(y));
                this.value = this.selectedID;
                this.loadDone.emit(null);
            });
        
        
    }
    
}